import type { CSSProperties, ReactNode } from 'react'

export type FeatureIconType = 'blind' | 'scouting' | 'spot' | 'waypoint' | 'path' | 'stand'

const ICONS: Record<FeatureIconType, { content: ReactNode; mode: 'fill' | 'stroke'; viewBox?: string }> = {
  blind: {
    mode: 'fill',
    viewBox: '0 0 24 20',
    content: (
      <>
        <path d="M14.9154 4.92768C14.8895 4.83048 14.8662 4.73623 14.8351 4.64492C14.6407 4.09118 14.3893 3.56984 14.0886 3.08091C13.7335 2.50066 13.3162 1.99699 12.8393 1.57285C12.5231 1.28715 12.1836 1.03384 11.8181 0.81588C11.0924 0.382904 10.3044 0.150217 9.49319 0.0500727H9.48801C9.21067 0.0176731 8.93334 0 8.65601 0C8.0521 0 7.44819 0.0795264 6.84947 0.226797C6.26629 0.374068 5.7194 0.589083 5.20621 0.877734C4.53491 1.2518 3.92063 1.74369 3.3556 2.34161C2.81908 2.90713 2.35254 3.52861 1.9508 4.20311C1.59053 4.80397 1.2821 5.44607 1.02032 6.12352C0.673002 7.02482 0.418997 7.94968 0.250525 8.90105C0.144257 9.51369 0.0742751 10.1352 0.0405805 10.7684C-0.0190328 11.8229 -0.0268068 12.8803 0.113155 13.9289C0.227198 14.7624 0.372342 15.5871 0.613387 16.3853C0.78186 16.942 0.971068 17.4869 1.18101 18.0201C2.18666 17.5547 3.30636 17.319 4.52973 17.319C6.34923 17.319 7.93287 17.8551 9.23918 18.9184C9.43617 19.0804 9.62797 19.2512 9.80681 19.4309C9.60723 19.1364 9.41543 18.8359 9.22882 18.5296C8.89706 17.9877 8.60676 17.4133 8.37609 16.8065C8.11949 16.1173 7.94842 15.4045 7.98212 14.6417C8.03396 13.3751 8.53678 12.409 9.48541 11.7493C9.83273 11.5048 10.2163 11.3516 10.6129 11.2338C10.9835 11.1278 11.3619 11.1366 11.7352 11.1013H11.7715C11.8933 11.1013 12.0203 11.1455 12.1369 11.1455C12.2069 11.1455 12.2717 11.1278 12.3313 11.0777C12.4894 10.9452 12.5983 10.7331 12.7253 10.5505C13.0881 10.0262 13.3992 9.47835 13.6532 8.90105C14.0601 7.99386 14.3322 7.01598 14.4644 5.9733C14.4903 5.76123 14.5033 5.54622 14.5189 5.33415C14.5318 5.12208 14.5344 5.11324 14.7132 5.08673C14.7573 5.08084 14.8014 5.08084 14.8454 5.07495C14.9025 5.06317 14.9362 4.99543 14.9154 4.92768ZM9.9675 5.79363C9.79644 5.79363 9.63315 5.74356 9.49319 5.65814C9.18475 5.46669 8.97481 5.09262 8.97481 4.66848C8.97481 4.24434 9.18475 3.86733 9.49319 3.67588C9.63315 3.59046 9.79644 3.54039 9.9675 3.54039C10.5118 3.54039 10.955 4.04406 10.955 4.66848C10.955 5.29291 10.5118 5.79363 9.9675 5.79363Z" />
        <path d="M23.6191 10.3917C23.4273 10.8247 23.1785 11.2017 22.8337 11.4992C22.4683 11.8085 22.0743 12.0441 21.6363 12.1884C21.2034 12.3327 20.7628 12.4211 20.3092 12.4299C20.1252 12.4358 19.9412 12.4565 19.7675 12.4565C19.682 12.4565 19.5991 12.4506 19.5187 12.4358H19.3528C19.2699 12.4358 19.187 12.4358 19.1066 12.4358C18.2565 12.4358 17.4193 12.3033 16.5899 12.103C15.7527 11.9027 14.9155 11.6877 14.0939 11.4226C13.9799 11.3873 13.8684 11.3578 13.757 11.3136C13.5833 11.2459 13.5729 11.1811 13.6688 11.0368C14.0421 10.4683 14.3661 9.86154 14.6512 9.23122C14.7004 9.12224 14.7497 9.01032 14.7911 8.89839C15.0685 8.21211 15.2499 7.49048 15.3691 6.74824C15.4054 6.50672 15.4469 6.26519 15.4883 6.02367C15.5039 6.01778 15.5194 6.01483 15.535 6.01483C15.6413 6.01483 15.7061 6.11498 15.7838 6.17683C15.8797 6.25341 15.9652 6.34177 16.0586 6.41835C16.4136 6.71584 16.7661 7.02511 17.1264 7.31376C17.1575 7.34027 17.186 7.36383 17.2171 7.38739C18.4483 8.37116 19.7727 9.14581 21.206 9.67598C21.6493 9.84093 22.1028 9.94402 22.5616 10.0324C22.8778 10.0972 23.194 10.1296 23.5128 10.1472C23.6424 10.1531 23.6813 10.2474 23.6191 10.3888V10.3917Z" />
      </>
    ),
  },
  scouting: {
    mode: 'fill',
    content: (
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-5.01-1.56l2.11-4.89 4.89-2.11-2.11 4.89-4.89 2.11zm5.51-5.94c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" />
    ),
  },
  spot: {
    mode: 'fill',
    content: (
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
    ),
  },
  waypoint: {
    mode: 'fill',
    content: (
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
    ),
  },
  path: {
    mode: 'stroke',
    content: (
      <>
        <polyline points="3 17 9 11 13 15 21 7" />
        <line x1="14" y1="7" x2="21" y2="7" />
        <line x1="21" y1="7" x2="21" y2="14" />
      </>
    ),
  },
  stand: {
    mode: 'fill',
    viewBox: '0 0 15 15',
    content: (
      <path d="M11 0L11 7.94L12.49 14.39C12.55 14.66 12.38 14.93 12.11 14.99C11.87 15.04 11.63 14.92 11.54 14.7L11.51 14.61L11.29 13.64L7.5 10.97L3.71 13.64L3.49 14.61C3.43 14.88 3.16 15.05 2.89 14.99C2.65 14.93 2.49 14.71 2.5 14.48L2.51 14.39L4 7.94L4 1L11 0ZM10.23 9.05L8.37 10.36L10.95 12.18L10.23 9.05ZM4.77 9.05L4.05 12.18L6.63 10.36L4.77 9.05ZM9.98 8L5.02 8L7.5 9.75L9.98 8ZM7 3L5 3L5 4L7 4L7 3ZM10 3L8 3L8 4L10 4L10 3Z" />
    ),
  },
}

export type FeatureIconProps = {
  type: FeatureIconType
  className?: string
  size?: number
  style?: CSSProperties
}

export function FeatureIcon({ type, className, size = 16, style }: FeatureIconProps) {
  const { mode, content, viewBox } = ICONS[type]
  const strokeProps =
    mode === 'stroke'
      ? { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const }
      : { fill: 'currentColor' }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={viewBox ?? '0 0 24 24'}
      aria-hidden="true"
      className={className}
      style={style}
      {...strokeProps}
    >
      {content}
    </svg>
  )
}
